"use strict";

// базовый виджет
$.widget("fotobook.calendarColorsWidget", $.fotobook.baseColorWidget, {
    _styleCssSelector: null,
    _create: function(){
        this._styleCssSelector = "css-" + this.eventNamespace.substring(1);
        this._super();
    },
    _colorPickerSetColor: function(color){
        this._setPreviewStyle(color);
    },
    _colorPickerCancel: function(){
        this._removePreviewStyle();
    },
    _colorPickerOk: function(color){
        Fotobook.containers.changeContainerAttrs({
            [this.getContainerId()] : {
                "calendar" : {
                    [this.options.field] : color,
                }
            }
        }).catch(
            () => {}
        ).finally(() => {
            this._removePreviewStyle();
        });
    },
    _setPreviewStyle: function(color){
        var fields = {},
            container = this.getContainer();

        fields[this.options.field] = color;
        fields["highlight_item"] = container.data("highlight_item");
        fields["highlight_value"] = container.data("highlight_value");
        this._styleCssSelector = Fotobook.containers.calendar.style.addOverride(this.options.container, this.options.template, fields, this._styleCssSelector);
    },
    _removePreviewStyle: function(){
        Fotobook.containers.calendar.style.removeOverride(this._styleCssSelector);
    },
    _getColorFromProject: function(){
        return this.options.container.attr("data-" + this.options.field);
    },
    _destroy: function(){
        Fotobook.containers.calendar.style.removeOverride(this._styleCssSelector);
        this._super();
    },
});

// цвет фона ячеек
$.widget("fotobook.calendarColorsNumbersBackgroundWidget", $.fotobook.calendarColorsWidget, {
    _getCreateOptions: function(){
        return {
            "template" : "backgroundColor",
            "field"    : "background_color",
        };
    },
});

// цвет текста заголовка - месяца и года
$.widget("fotobook.calendarColorsMonthTextWidget", $.fotobook.calendarColorsWidget, {
    _getCreateOptions: function(){
        return {
            "template" : "monthColor",
            "field"    : "month_color",
        };
    },
    _checkEnabled: function(){
        return Fotobook.containers.calendar.headerIsVisible(this.options.container);
    },
});

// цвет текста обычных дней
$.widget("fotobook.calendarColorsNumbersTextWidget", $.fotobook.calendarColorsWidget, {
    _getCreateOptions: function(){
        return {
            "template" : "regularColor",
            "field"    : "numbers_color",
        };
    },
});

// цвет выходных и праздничных дней
$.widget("fotobook.calendarColorsHolidaysTextWidget", $.fotobook.calendarColorsWidget, {
    _getCreateOptions: function(){
        return {
            "template" : "weekendColor",
            "field"    : "holidays_color",
        };
    },
});

// цвет рамки
$.widget("fotobook.calendarColorsBorderWidget", $.fotobook.calendarColorsWidget, {
    _getCreateOptions: function(){
        return {
            "template" : "borderColor",
            "field"    : "border_color",
            "alpha"    : false,
        };
    },
});

// цвет текста дней из соседних месяцев
$.widget("fotobook.calendarColorsExternalTextWidget", $.fotobook.calendarColorsWidget, {
    _checkEnabled: function(){
        return Fotobook.containers.calendar.externalMonthAreVisible(this.options.container);
    },
    _getCreateOptions: function(){
        return {
            "template" : "externalColor",
            "field"    : "numbers_color_external",
        };
    },
});

// цвет текста названий дней
$.widget("fotobook.calendarColorsDayNameTextWidget", $.fotobook.calendarColorsWidget, {
    _checkEnabled: function(){
        return Fotobook.containers.calendar.dayNamesAreVisible(this.options.container);
    },
    _getCreateOptions: function(){
        return {
            "template" : "dayNameColorText",
            "field"    : "day_name_color_text",
        };
    },
});

// цвет фона названий дней
$.widget("fotobook.calendarColorsDayNameBackgroundWidget", $.fotobook.calendarColorsWidget, {
    _checkEnabled: function(){
        return Fotobook.containers.calendar.dayNamesAreVisible(this.options.container);
    },
    _getCreateOptions: function(){
        return {
            "template"        : "dayNameColorBackground",
            "field"           : "day_name_color_background",
        };
    },
});

// цвет текста номеров недель
$.widget("fotobook.calendarColorsWeekNumbersTextWidget", $.fotobook.calendarColorsWidget, {
    _checkEnabled: function(){
        return Fotobook.containers.calendar.weekNumbersAreVisible(this.options.container);
    },
    _getCreateOptions: function(){
        return {
            "template" : "weekNumbersColor",
            "field"    : "week_numbers_color",
        };
    },
});

// цвет фона номеров недель
$.widget("fotobook.calendarColorsWeekNumbersBackgroundWidget", $.fotobook.calendarColorsWidget, {
    _checkEnabled: function(){
        return Fotobook.containers.calendar.weekNumbersAreVisible(this.options.container);
    },
    _getCreateOptions: function(){
        return {
            "template" : "weekNumbersBackgroundColor",
            "field"    : "week_numbers_background_color",
        };
    },
});

/** цвет текста второстепенных дней */
$.widget("fotobook.numberSecondaryColorWidget", $.fotobook.calendarColorsWidget, {
    _checkEnabled: function(){
        return this.options.container.find(".day-secondary-weekend").length > 0;
    },
    _getCreateOptions: function () {
        return {
            "template": "numberSecondaryColor",
            "field": "holidays_secondary_color",
        };
    },
});

/** цвет фона второстепенных дней */
$.widget("fotobook.numberSecondaryColorBackgroundWidget", $.fotobook.calendarColorsWidget, {
    _checkEnabled: function(){
        return this.options.container.find(".day-secondary-weekend").length > 0;
    },
    _getCreateOptions: function () {
        return {
            "template": "numberSecondaryColorBackground",
            "field": "holidays_secondary_background_color",
        };
    },
});
/** цвет фона основных выходных дней */
$.widget("fotobook.holidayBackgroundColorWidget", $.fotobook.calendarColorsWidget, {
    _checkEnabled: function(){
        return this.options.container.find(".day-weekend").length > 0;
    },
    _getCreateOptions: function () {
        return {
            "template": "holidayBackgroundColor",
            "field": "holidays_background_color",
        };
    },
});
